import * as React from 'react';
import { LayoutChangeEvent, Platform, View } from 'react-native';
import { theme } from 'lib/theme';
import { ResizableSidebar } from '../../components/ResizableSidebar';
import { useDrawerStatus } from '@react-navigation/drawer';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Glass } from 'components/Glass';
import { BlurView } from 'expo-blur';
import { PageNavigation } from './PageNavigation';

export const PageSidebar: React.FC<{
  onLayout: (event: LayoutChangeEvent) => void;
  width: number;
  resizable: boolean;
  forceResizable: boolean;
}> = ({ onLayout, width, resizable, forceResizable }) => {
  const drawerStatus = useDrawerStatus();

  const { top: safeAreaTop } = useSafeAreaInsets();

  const marginTop =
    Platform.OS === 'ios' ? safeAreaTop || 0 : safeAreaTop || theme.padding / 2;

  const Children = React.useMemo(
    () => (
      <Glass
        style={{
          flex: 1,
          borderRadius: 22,
        }}
        backgroundColor={theme.colors.white50}
      >
        <View style={{ borderRadius: 22, overflow: 'hidden', flex: 1 }}>
          <PageNavigation />
        </View>
      </Glass>
    ),
    [],
  );

  const WithBlur =
    Platform.OS === 'ios' ? (
      <View
        style={{
          flex: 1,
          marginLeft: theme.padding,
          marginBottom: theme.padding,
          marginTop,
        }}
      >
        {Children}
      </View>
    ) : (
      <BlurView
        style={{
          flex: 1,
          marginLeft: theme.padding / 2,
          marginBottom: theme.padding / 2,
          marginTop,
          borderRadius: 22,
        }}
        intensity={30}
        tint="light"
      >
        {Children}
      </BlurView>
    );

  return forceResizable || (resizable && drawerStatus === 'open') ? (
    <ResizableSidebar
      startWidth={width}
      minWidth={190}
      maxWidth={400}
      onLayout={onLayout}
    >
      {WithBlur}
    </ResizableSidebar>
  ) : (
    WithBlur
  );
};
